export const EDITOR_ONBOARDING_STEPS = [
  {
    id: 'pool-params-intro',
    iconId: 'sliders',
    label: 'ПАРАМЕТРЫ БАССЕЙНА',
    title: 'Начните с бассейна',
    body: 'Введите габариты, выберите тип и конфигурацию. Система автоматически рассчитает объём и подберёт подходящее оборудование.',
    targetSelector: '#onboarding-pool-params-intro',
    placement: 'right',
    showPulse: true,
  },
  {
    id: 'site-control',
    iconId: 'layout-dashboard',
    label: 'ПАНЕЛЬ УПРАВЛЕНИЯ',
    title: 'Всё управление в одном месте',
    body: 'Переключайтесь между видами камеры, настраивайте параметры и ширину борта — не уходя с экрана.',
    targetSelector: '#site-control-panel',
    placement: 'top',
    showPulse: false,
  },
  {
    id: 'equipment-panel',
    iconId: 'package',
    label: 'ОБОРУДОВАНИЕ',
    title: 'Только подходящие варианты',
    body: 'Система уже отфильтровала оборудование под параметры бассейна. Выберите оптимальный вариант по цене и характеристикам.',
    targetSelector: '#equipment-panel',
    placement: 'left',
    showPulse: true,
  },
  {
    id: 'ai-assistant',
    iconId: 'bot',
    label: 'ИИ‑КОНСУЛЬТАНТ',
    title: 'Персональный помощник',
    body: 'Знает всё об оборудовании и проектировании. Задайте вопрос — получите точный ответ мгновенно.',
    targetSelector: '.ai-floating-btn',
    placement: 'left',
    showPulse: true,
  },
  {
    id: 'scene-3d',
    iconId: 'box',
    label: '3D‑СЦЕНА',
    title: 'Управляйте каждой деталью',
    body: 'Нажмите на любое оборудование в сцене для детального просмотра оборудования и изучения его параметров.',
    targetSelector: '#scene-3d-viewport',
    placement: 'left',
    showPulse: false,
  },
];
